import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';
import FancyHoverImg from 'core/components/FancyHoverImg';
import {
	Card,
	Title,
	CardDate,
} from './listicleCardStyles';


const ListicleCard = ({
	slug, title, image, updatedAt
}) => {
	return (
		<Card href={`/box-insider/${slug}/`}>
			<FancyHoverImg
				src={image}
				alt={title}
				title={title}
				width="120"
				height="80"
			/>
			<Title>{title}</Title>
			<CardDate>{format(parseUTC(updatedAt), 'LLLL yyyy')}</CardDate>
		</Card>
	);
};

ListicleCard.propTypes = {
	slug: PropTypes.string,
	title: PropTypes.string,
	image: PropTypes.string,
	updatedAt: PropTypes.string,
};

export default ListicleCard;
